const translation = {
	helloWorld: "Hello, world!"
} as const;

export default translation;
